import axios from "axios";
import {
  ExchangeOffer,
  EscrowTransaction,
  CreateOfferRequest,
  MatchOfferRequest,
  DisputeEscrowRequest,
} from "../types/exchange";

const API_URL = process.env.REACT_APP_API_URL || "";
const API = "/api/exchange";
// Helper to get the Authorization header
const getAuthHeader = () => {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const exchangeService = {
  // Offers
  createOffer: async (offer: CreateOfferRequest): Promise<ExchangeOffer> => {
    const response = await axios.post(`${API_URL}/api/exchange/offers`, offer, {
      headers: getAuthHeader(),
    });
    return response.data;
  },
  getMyEscrows: async () => {
    const res = await axios.get(`${API}/my_escrows`, {
      headers: { Authorization: "Bearer " + localStorage.getItem("token") },
    });
    return res.data;
  },

  listOffers: async (status?: string): Promise<ExchangeOffer[]> => {
    const url = status
      ? `${API_URL}/api/exchange/offers?status=${status}`
      : `${API_URL}/api/exchange/offers`;
    // Listing offers may or may not require auth, adjust as needed:
    const response = await axios.get(url, { headers: getAuthHeader() });
    return response.data;
  },

  matchOffer: async (
    offerId: string,
    request: MatchOfferRequest
  ): Promise<EscrowTransaction> => {
    const response = await axios.post(
      `${API_URL}/api/exchange/offers/${offerId}/match`,
      request,
      { headers: getAuthHeader() }
    );
    return response.data;
  },

  // Escrow
  fundEscrow: async (escrowId: string): Promise<EscrowTransaction> => {
    const response = await axios.post(
      `${API_URL}/api/exchange/escrow/${escrowId}/fund`,
      {},
      { headers: getAuthHeader() }
    );
    return response.data;
  },

  confirmDelivery: async (escrowId: string): Promise<EscrowTransaction> => {
    const response = await axios.post(
      `${API_URL}/api/exchange/escrow/${escrowId}/confirm_delivery`,
      {},
      { headers: getAuthHeader() }
    );
    return response.data;
  },

  releaseEscrow: async (escrowId: string): Promise<EscrowTransaction> => {
    const response = await axios.post(
      `${API_URL}/api/exchange/escrow/${escrowId}/release`,
      {},
      { headers: getAuthHeader() }
    );
    return response.data;
  },

  disputeEscrow: async (
    escrowId: string,
    request: DisputeEscrowRequest
  ): Promise<EscrowTransaction> => {
    const response = await axios.post(
      `${API_URL}/api/exchange/escrow/${escrowId}/dispute`,
      request,
      { headers: getAuthHeader() }
    );
    return response.data;
  },
};
